const TripLogsArchive = (function ($) {
	return class {
		constructor($el) {
			this.$el = $el;

			this.$searchInput = this.$el.find('.banner-archive-trip-logs .banner-archive-trip-logs__search-container input');

			if (this.$searchInput.length) {
				const $parentInputContainer = this.$searchInput.parents('.banner-archive-trip-logs__search-container');

				$parentInputContainer.on('click tap', (e) => {
					$(e.currentTarget).addClass('expanded');
					this.$searchInput.focus();
				});

				this.$searchInput.focus((e) => {
					const $siblings = $(e.currentTarget).parents('.columns').removeClass('shrink').siblings('.columns');

					$parentInputContainer.addClass('expanded');

					if ($(window).width() <= 640) {
						$siblings.first().hide();
					} else {
						$siblings.hide();
					}
				});

				this.$searchInput.blur((e) => {
					$parentInputContainer.removeClass('expanded');
					$(e.currentTarget).parents('.columns').addClass('shrink').siblings('.columns').show();
				});
			}

			$('.banner-archive-trip-logs select').change((e) => {
				// if this is the year filter we need to reset all the other filters
				if ($(e.currentTarget).attr('name') === 'filter_year') {
					this.$el.find('.banner-archive-trip-logs select:not([name="filter_year"]) option:selected').prop('selected', false);
				}

				this.refreshWithFilters();
			});
		}

		refreshWithFilters() {
			let filteredUrl = this.$el.find('.banner-archive-trip-logs__form-container').attr('action');
			const queryParts = [];

			this.$el.find('.banner-archive-trip-logs select').each(function () {
				var name = $(this).attr('name');
				var value = Number($(this).val());

				if (name && value) {
					queryParts.push(`${name}=${value}`);
				}
			});

			if (queryParts.length) {
				filteredUrl += `?${queryParts.join('&')}`;
			}

			window.open(filteredUrl, '_self');
		}
	};
})(jQuery);

export default TripLogsArchive;
